<ng-container *transloco="let t">
  <section
    id="TabbyPromoContainer"
    class="tabby-promo-container"
    (click)="logClickEvent()"></section>
</ng-container>
